import { render, staticRenderFns } from "./AboutBanner3.vue?vue&type=template&id=3518cad8&"
import script from "./AboutBanner3.vue?vue&type=script&lang=js&"
export * from "./AboutBanner3.vue?vue&type=script&lang=js&"
import style0 from "./AboutBanner3.vue?vue&type=style&index=0&id=3518cad8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports